import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  dataRequest,
  selectRequestsStateByGroupId,
  selectItemsByGroupId,
  selectLastItemByGroupId
} from 'mt-react-common/common/reducers/listsCollection/reducer';

import TaskExecLogItem from '../TaskExecLogItem';
import OpacityPreLoader from '../../../../../components/Common/PreLoaders/OpacityPreLoader';

const tasksExecLogCollectionRName =
  'tasksModule.collections.tasksExecLogCollection';

class TaskExecLogsBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasShowAllLogs: false
    };
  }

  render() {
    let log = null;
    if (!this.state.hasShowAllLogs) {
      log = (
        <div>
          <div className="form-group">
            <button
              className="btn btn-muted btn-block btn-sm"
              onClick={() => {
                this.setState({ hasShowAllLogs: true });
                this.props.dataRequest();
              }}
            >
              {t('Показать все сообщения')}
            </button>
          </div>
          <TaskExecLogItem execLogItem={this.props.lastItemByExec} />
        </div>
      );
    } else {
      log = (
        <div>
          <div className="form-group">
            <button
              className="btn btn-muted btn-block btn-sm"
              onClick={() => this.setState({ hasShowAllLogs: false })}
            >
              {t('Показать только последнее')}
            </button>
          </div>
          {Object.keys(this.props.logsItems).map(key => (
            <TaskExecLogItem
              key={`execLog${key}`}
              execLogItem={this.props.logsItems[key]}
              userRepeatsAmount={this.props.userRepeatsAmount}
            />
          ))}
        </div>
      );
    }
    return (
      <React.Fragment>
        {this.props.selectRequestsStateByGroupId.requestInProcess ? (
          <OpacityPreLoader />
        ) : null}
        {log}
      </React.Fragment>
    );
  }
}

TaskExecLogsBlock.propTypes = {
  // IN
  // eslint-disable-next-line react/no-unused-prop-types
  execId: PropTypes.number.isRequired,
  userRepeatsAmount: PropTypes.number,
  // CONNECT
  dataRequest: PropTypes.func.isRequired,
  selectRequestsStateByGroupId: PropTypes.shape({
    requestInProcess: PropTypes.bool,
    lastStatusCode: PropTypes.number,
    countQueries: PropTypes.number
  }).isRequired,
  logsItems: PropTypes.shape({}).isRequired,
  lastItemByExec: PropTypes.shape({}).isRequired
};

TaskExecLogsBlock.defaultProps = {
  userRepeatsAmount: null
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => ({
  selectRequestsStateByGroupId: selectRequestsStateByGroupId(
    state,
    tasksExecLogCollectionRName,
    props.execId
  ),
  logsItems: selectItemsByGroupId(
    state,
    tasksExecLogCollectionRName,
    props.execId
  ),
  lastItemByExec: selectLastItemByGroupId(
    state,
    tasksExecLogCollectionRName,
    props.execId
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  dataRequest: () =>
    dispatch(dataRequest(tasksExecLogCollectionRName, props.execId))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TaskExecLogsBlock)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskExecLogsBlock/TaskExecLogsBlock.js